export default __webpack_public_path__ + "static/credit-cards-e15513156a27815d9918ef1ebc0cdfb4.webp";